<div class="dropdown mb-3" [class.show]="showOptions && !readOnly">
  
  <input
    type="text" 
    class="form-select form-select-sm" 
    [id]="id" 
    [(ngModel)]="searchTerm" 
    (input)="onSearch()"
    (click)="!readOnly && onDropdownClick()" 
    (blur)="!readOnly && onBlur()" 
    [placeholder]="placeholder" 
    [disabled]="disabled"
    [attr.aria-expanded]="showOptions && !readOnly" 
    aria-haspopup="true" 
    [ngClass]="{'is-invalid': invalid}"
    [readOnly]="readOnly"
    (change)="onValueChange($event.target.value)"
  />

  <ul class="dropdown-menu w-100" [class.show]="showOptions && !readOnly">
  
  <li 
    *ngFor="let option of filteredOptions; let i = index" 
    class="dropdown-item"
    [ngClass]="{ 'active': isActive(i) }" 
    (mouseenter)="!readOnly && onHover(i)" 
    (mouseleave)="!readOnly && onMouseLeave()"
    (mousedown)="!readOnly && selectOption(option)">{{ option }}</li>

  <li *ngIf="filteredOptions.length === 0" class="text-muted text-center py-3 matches">
    No matches found
  </li>

  </ul>

  <div class="invalid-feedback" *ngIf="invalid">{{ errorMessage }}</div>

</div>